import React from "react";
import queryString from "query-string";
import { FormattedHTMLMessage } from "react-intl";
import { Route } from "react-router-dom";
import MainMenu from "../components/MainMenu";



const NewPartnership = React.createClass({
  render() {
    const { location } = this.props;
    const query = queryString.parse(location.search || "?l=en");
    const languageID = query.l || "en";

    return (
      <div>
        <div className='NewPartnership-desktop'>
          <div className='NewPartnership-container'>
            <Route path='/' component={MainMenu} />
            
            <div className='NewPartnership'>

            

            <div className={`NewPartnership-content full language-${languageID}`}>
                <div className='NewPartnership-title'>
                  {<FormattedHTMLMessage id={"pages:new-partnership:title"} />}
                </div>
                <div className='NewPartnership-description'>
                  <div style={{ width: '280px', float: 'left', margin: '40px', marginTop: '30px' }}>
                    <span><a href="https://www.solarlightingitl.com" target="_blank"><img src="images/logotypes/sli.png" style={{ height: '150px' }} /></a></span>
                  </div>
                  <div style={{ display: 'inline' }}>                    
                    <p style={{paddingTop: '30px'}}>ART is glad to inform the users about its new partnership with <b style={{fontWeight: 'bold'}}>Solar Lighting International, Inc.</b>, an United States company leader in the street lighting sector and not only.</p>
                    <p>This partnership is oriented to make <b style={{fontWeight: 'bold'}}>SLI</b> a well-known and appreciated brand for the quality of its products, also in the Mediterranean basin and Europe as it already is in the rest of the world.</p>
                    <p>The high technology used in <b style={{fontWeight: 'bold'}}>SLI</b> products, offered at very attractive prices, makes them ideal and easy to use in the <b style={{fontWeight: 'bold'}}>Oil & Gas market</b> as well as both the industrial and the private sectors.</p>                  
                  </div>
                </div>

                <div className='NewPartnership-description' style={{clear: 'both', paddingBottom: '30px'}}>
                  <div style={{ width: '60%', float: 'left', marginTop: '40px' }}>
                    <p>Solar Lighting International, Inc. was started in 2006 after being split off from SC Solar, Inc. to bring custom-engineered solar lighting and traffic management applications to the forefront of much-needed infrastructure upgrades in the U.S. and worldwide.</p>
                    <p>Solar Lighting International, Inc. is an industry-leading designer and manufacturer of superior commercial solar lighting products. We have been manufacturing solar lighting systems since 2004 when the X-35 series commercial solar light was released. We have expanded since then and offer a wide range of solar LED street and parking lot lighting systems, as well as a wide range of pathway lighting, solar traffic and safety products, and custom lighting applications. Our products are designed and engineered in the United States and are a symbol of high-quality solar lighting solutions.</p>
                    <p>All of our solar LED light solutions are versatile, with the ability to be either ground or pole-mounted, for any size project. These systems also come backed by a 5-year comprehensive warranty, giving you the peace of mind to make the choice of solar LED lighting solution without the fear of needing to hire specialized experts to your staff. Solar Lighting International has offices in South Carolina and Amman, Jordan. We have a variety of selected installing partners in the US Virgin Islands, Puerto Rico, California, Arizona, Colorado, Connecticut, Saudi Arabia, and Bahrain. With a diverse group of contractors and partners, SLI has a global engineering and sales workforce experienced in project analysis and implementation. Providing the ultimate in customer service, SLI is blessed to have loyal and repeat customers.</p>
                    <br/>
                    <b style={{fontWeight: 'bold', fontStyle: 'italic'}}> We hope you will join our vision and become part of the SLI family.</b>
                  </div>
                  <div style={{ width: '40%', float: 'right', paddingLeft: '50px', marginTop: '40px' }}>
                    <p style={{ fontSize: '30px', color: '#00aeef', lineHeight: '38px', fontStyle: 'italic' }}>With a diverse group of contractors and partners, SLI has developed a global force experienced in project analysis and implementation.</p>
                  </div>
                </div>

                <div className='NewPartnership-description' style={{clear: 'both',  marginTop: '40px', paddingTop: '10px' }}>
                  {/* <span><img src="images/backgrounds/sli-space.png" style={{ width: '100%', marginTop: '40px' }} /></span> */}
                  <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/sli-space.png")',
                    backgroundPosition: '0',
                    backgroundSize: 'cover',
                    backgroundPosition: 'top',                    
                    maxHeight: '700px',
                    height: '800px',
                    width: '100%',          
                    marginTop: '40px'                     
                  }}
                  ></div>
                </div>


                <div className='NewPartnership-description' style={{clear: 'both' }}>
                  <span style={{ width: '100%', textAlign: 'center' }}>
                    <p style={{ fontSize: '24', lineHeight: '38px', fontStyle: 'bold', marginTop: '50px' }}>
                      Contact Us
                    </p>
                    <p style={{ fontSize: '18', fontStyle: 'bold', marginTop: '10px' }}>
                      <b>USA</b>
                    </p>
                    <p>Phone: +1.803.233.3461</p>
                    <p>Website: <a href="https://www.solarlightingitl.com" target="_blank">www.solarlightingitl.com</a></p>

                    <p style={{ fontSize: '18', fontStyle: 'bold', marginTop: '7px' }}>
                      <b>EUROPE</b>
                    </p>
                    <p>
                    Phone: +39 2 5578271<br />
                    Email: <a href="mailto:artechno@artechno.it">Sli-EU@artechno.it</a>
                    </p>

                  </span>
                </div>
              </div>

              {/* <div className={`NewPartnership-content language-${languageID}`}>
                <div className='NewPartnership-title'>
                  {<FormattedHTMLMessage id={"pages:new-partnership:title"} />}
                </div>
                <div className='NewPartnership-description'>
                  {<FormattedHTMLMessage id={"pages:new-partnership:description"} />}
                </div>
              </div> */}

              
              {/* <div className='NewPartnership-images'>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/partnership_1.jpg")'
                  }}
                ></div>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/partnership_2.png")',
                    backgroundPosition: '0',
                    height: '80%'
                  }}
                ></div>
              </div> */}

            </div>
          </div>
        </div>


      </div>
    )

  }
})

export default NewPartnership;



// WEBPACK FOOTER //
// ./src/sections/NewPartnership.js